import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function Nav() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-50 backdrop-blur-md bg-[#FAF7F2]/85 border-b border-[#E8E1D9]">
      <div className="max-w-6xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2.5 shrink-0">
          <img src="/logo-mark.png" alt="RelateMetrics" className="h-9 w-auto" />
          <span className="hidden sm:inline font-display text-2xl font-semibold tracking-tight text-[#2B2625]">
            RelateMetrics
          </span>
        </Link>
        <nav className="flex items-center gap-1 sm:gap-4 text-sm">
          <Link to="/ebook" data-testid="nav-ebook" className="text-[#6E655F] hover:text-[#6B21A8] transition-colors font-medium px-1.5 sm:px-2">
            eBook
          </Link>
          {user ? (
            <>
              <Link to="/dashboard" data-testid="nav-dashboard" className="text-[#6E655F] hover:text-[#6B21A8] transition-colors font-medium px-1.5 sm:px-2">
                Dashboard
              </Link>
              <button
                data-testid="nav-logout"
                onClick={() => { logout(); navigate("/"); }}
                className="text-[#6E655F] hover:text-[#6B21A8] font-medium px-1.5 sm:px-2"
              >
                Sign out
              </button>
            </>
          ) : (
            <Link
              to="/start"
              data-testid="nav-start"
              className="bg-[#6B21A8] hover:bg-[#4C1D95] text-white font-semibold py-2 px-4 sm:px-5 rounded-xl transition-colors active:scale-[0.98]"
            >
              Begin
            </Link>
          )}
        </nav>
      </div>
    </header>
  );
}
